export const CUSTOMER_MANAGEMENT = 'customer-management'
export const NEW_CUSTOMER = `${CUSTOMER_MANAGEMENT}/new`
